import { ButtonProps } from 'modules/queryBuilder/contexts';
import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { Exit16 } from 'ui/icons/aurora/16px/Exit16';
import { BUTTON_VARIANTS } from 'ui/button';
import { QueryBuilderIconButton } from './QueryBuilderIconButton';

export const DATA_TEST = {
  button: 'remove-condition-button',
};

export const RemoveConditionButton = (props: ButtonProps) => {
  const { t } = useTranslation();
  return (
    <QueryBuilderIconButton
      {...props}
      dataTest={DATA_TEST.button}
      tooltipContent={t('storybook.buttons.tooltips.remove')}
      Icon={Exit16}
      variant={BUTTON_VARIANTS.GHOST}
    />
  );
};
